<template>
  <div class="home"></div>
</template>

<script>
import { reloadMixin } from "@/mixins/reloadMixin";

export default {
  name: "Home",
  components: {},
  mixins: [reloadMixin]
};
</script>
